import { parse } from 'qs';
export const getWindowQueryString = () => typeof window !== 'undefined' ? window.location.search : '';
// get the current query string
export const getQueryString = (queryString = getWindowQueryString()) => parse(queryString, { ignoreQueryPrefix: true, depth: 0 });
// get a certain key from a query string
export const getQueryStringValue = (key, queryString = getWindowQueryString()) => {
    const values = getQueryString(queryString);
    return key in values ? String(values[key]) : null;
};
// get array of entries from query string
export const getQueryStringArrayValues = (key, queryString = getWindowQueryString()) => {
    const values = getQueryString(queryString);
    return Object.entries(values).reduce((acc, [k, v]) => {
        if (k.startsWith(key) && typeof v === 'string')
            acc.push(v);
        return acc;
    }, []);
};
